export const TestImage =
  "https://mlstaticquic-a.akamaihd.net/aro-de-basketball-profesional-pelota-red-basket-el-rey-D_NQ_NP_836160-MLU26508816503_122017-O.webp";
export const IMG_PLACEHOLDER =
  "https://www.knauthe.com/components/com_easyblog/themes/wireframe/images/placeholder-image.png";
export const BRAND_NAME = "Get-it";
